import { Link, Text, View } from '@react-pdf/renderer';
import logo from '@ui/assets/images/MWS/MWS_HYPERCO_LOGO.png';
import { EnvConfig } from '@ui/config/env';

import { usePDFContext } from '../PDFProvider';
import { EmployeeInformation } from './components/EmployeeInformation';
import { Header } from './components/Header';
import { Logo } from './components/Logo';
import { Page } from './components/Page';
import { CustomerAddress } from './components/QuoteDetails/CustomerAddress';
import { CustomerContact } from './components/QuoteDetails/CustomerContact';
import { QuoteDetails } from './components/QuoteDetails/QuoteDetails';
import { QuoteInformation } from './components/QuoteDetails/QuoteInformation';
import { QuoteId } from './components/QuoteId';
import { QuoteLineForPart, QuoteLineForServices } from './components/QuoteLine';
import { PartId } from './components/QuoteLine/PartId';
import { PartSpecs } from './components/QuoteLine/PartSpecs';
import { SiteInformation } from './components/SiteInformation';
import { Specs } from './components/Specs';
import { styles } from './components/styles';

const MWS_SITE_INFORMATION = [
  '500 East Ottawa Street',
  'Logansport, IN 46947',
  'Phone (574) 722 - 8200',
  'Fax (574) 722 - 8241',
  <Text key="site-iso" style={[styles.bold, { padding: '15 0 15 5' }]}>
    ISO 9001 Registered
  </Text>,
];

export function MWSHypercoQuoteDocument() {
  const { quoteLines } = usePDFContext();

  return (
    <Page>
      <View style={[styles.row, { justifyContent: 'center' }]}>
        <Logo
          source={logo}
          extraStyles={[{ height: '28px', width: '200px' }]}
        />
      </View>
      <Header>
        <SiteInformation name="HYPERCO" items={MWS_SITE_INFORMATION} />

        {/* Some sites may have a different ecommerce site */}
        <QuoteId ecommerceUri={EnvConfig.getKey('MW_COMPONENTS_URI')} />
      </Header>

      <QuoteDetails>
        <CustomerAddress />

        <CustomerContact />

        <QuoteInformation />
      </QuoteDetails>

      {quoteLines.map((line) => {
        const { part, ...lineProps } = line;
        if (!part) {
          return <QuoteLineForServices {...line} showDescription />;
        }
        return (
          <QuoteLineForPart
            key={line.id}
            {...lineProps}
            part={part}
            showDrawing
          >
            <PartId part={part} showCustomerPartId />

            <PartSpecs specs={line.specs} />
          </QuoteLineForPart>
        );
      })}

      <Specs />

      <EmployeeInformation />

      <View style={[styles.row]}>
        <View style={styles.fullRow}>
          <Text>FOB our plant unless noted otherwise.</Text>
        </View>
      </View>
      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text style={[styles.textSmall]}>
            View Your Order Status & Tracking Online:
          </Text>
          <Text style={[styles.textSmall]}>
            For updates on your order status and tracking information, log in to
            your account on MWComponents.com using the same email address
            associated with your order. Navigate to My Account, then select
            Orders. If you do not already have an account, you can create one.
            Orders associated with the account email address will automatically
            populate.
          </Text>
        </View>
      </View>
      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text style={[styles.textSmall]}>
            Standard terms and conditions can be found on{' '}
            <Link href="https://www.mwcomponents.com/terms-and-conditions">
              https://www.mwcomponents.com/terms-and-conditions
            </Link>
          </Text>
        </View>
      </View>
    </Page>
  );
}
